import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input, OnDestroy, SkipSelf } from '@angular/core';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'jow-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('message', [
            transition(':enter', [
                style({
                    opacity: 0,
                    transform: 'translate3d(100%, 0, 0)'
                }),
                animate('500ms ease-in-out', style({
                    opacity: 1,
                    transform: 'translate3d(0, 0, 0)'
                }))
            ]),
            transition(':leave', [
                style({
                    opacity: 1
                }),
                animate('500ms ease-in-out', style({
                    opacity: 0,
                    transform: 'translate3d(-100%, 0, 0)'
                }))
            ])
        ])
    ],
    standalone: false
})
export class BannerComponent implements OnDestroy {

  @Input() 
  get messages(): string[] {
    return this._messages;
  }
  set messages(messages: string[]) {
    this._messages = messages;
    this.loop();
  }
  private _messages: string[];

  currentIndex = new BehaviorSubject<number>(0);

  @HostListener('mouseenter') enter() {
    this.subscription?.unsubscribe();
  }
  @HostListener('mouseleave') leave() {
    this.loop();
  }

  private subscription: Subscription;

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  setIndex(index: number) {
    this.currentIndex.next(index);
    this.loop();
  }

  private loop() {
    if (this.subscription) this.subscription.unsubscribe();

    if (this.messages?.length > 1) {
      this.subscription = interval(5000)
        .subscribe(_ => {
          if (this.currentIndex.value === this.messages.length - 1) {
            this.currentIndex.next(0);
          } else {
            this.currentIndex.next(this.currentIndex.value + 1);
          }
        });
    }
  }

}
